import {Component, OnInit, Input} from '@angular/core';
import {NgbActiveModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {LogService} from '../../services/log.service';
import {Log} from '../../model/log';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {BranchesShowComponent} from '../../views/setting/branches/branches-show/branches-show.component';
import {TranslateService} from "@ngx-translate/core";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {validate} from "codelyzer/walkerFactory/walkerFn";
import {ItemsGroup} from "../../views/setting/itemsGroups/itemsGroups";
import {User} from "../../model";
import {UserService} from "../../services/user.service";
import {Message} from "primeng/api";
import {Router} from "@angular/router";
import {CityService} from "../../views/setting/cities/cities.service";
import {ItemsGroupService} from "../../views/setting/itemsGroups/itemsGroups.service";

@Component({
    selector: 'app-user-profile',
    templateUrl: './parent-show.component.html',
    styleUrls: ['./parent-show.component.scss'],
    providers: []
})
export class ParentShowComponent implements OnInit {
    id: string;
    public user: User;
    city:any;
    public logs: Log[];
    oldPass: any;
    msgs: Message[] = [];
    @Input() refRec: any;

    @Input() scr;
    @Input() refShow;
    modalRef: NgbModalRef;
    form: FormGroup;
    cat:any;
    public group_type:any;
    public sts_val:any;
    constructor(public activeModal: NgbActiveModal,
                public logService: LogService,
                private router: Router,
                private userService: UserService,
                private itemsGroup: ItemsGroupService,
                private cityService: CityService,
                public translate: TranslateService,
                private formBuilder: FormBuilder,
                private modalService: NgbModal,) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            this.id = userdata.id;
            this.oldPass = userdata.password;
        }
    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            id: new FormControl({value: '', disabled: true}),
            name: new FormControl({value: '', disabled: true}),
            category: new FormControl({value: '', disabled: true}),
            items_types: new FormControl({value: '', disabled: true}),
            status: new FormControl({value: '', disabled: true}),


        });

        if(this.scr=='city' || this.scr=='customers') {
            this.cityService.getById(this.refRec).subscribe(
                city => {
                    this.form.controls['id'].setValue(city.id);
                    this.form.controls['name'].setValue(city.name);
                    this.cat = city.category;
                    if (city.category == 1) {
                        this.cat = 'Country';
                    } else if (city.category == 2) {
                        this.cat = 'State';
                    } else if (city.category == 3) {
                        this.cat = 'City';
                    }
                    if(city.status==1){
                        this.sts_val='Active';
                    } else if(city.status==2){
                        this.sts_val='Inactive';
                    }
                }
            );
        }
        if(this.scr=='items'){
            this.itemsGroup.getById(this.refRec).subscribe(
                gr=>{
                    this.form.controls['id'].setValue(gr.id);
                    this.form.controls['name'].setValue(gr.name);

                    if (gr.items_types == 1) {
                        this.group_type = 'Origin';
                    } else if (gr.items_types == 2) {
                        this.group_type = 'Services';
                    } else if (gr.items_types == 3) {
                        this.group_type = 'Consumables';
                    }
                    if(gr.status==1){
                        this.sts_val='Active';
                    } else if(gr.status==2){
                        this.sts_val='Inactive';
                    }
                }

            )
        }

        if (this.refRec) {


            // this.id = this.refRec.id;
          //  window.alert('hey '+this.refRec);
            let rec = this.refRec;
            this.refRec = rec;
            /*if(rec.trans_status == 1){
                this.sts="Not Accredited";
            }else if(rec.trans_status ==2){
                this.sts="Accredited";
            }
            if(rec.synce_status == 0){
                this.sync_sts ='Not synchronized';
            }else if(rec.synce_status ==1){
                this.sync_sts ='Has been synchronized';
            }
            if(rec.status==0){
                this.rec_sts="Active";
            }else if(rec.status){
                this.rec_sts="Inactive";
            }*/
            this.form.patchValue({
                id: rec.id,
                // creation_user: this.userName,
                name: rec.name,
                creation_date: rec.created_at,
                update_date: rec.updated_at,
              //  trans_status:this.sts,
                // last_update_user:rec.last_update_user,
                last_update_ip:rec.last_update_ip,
                sync_date:rec.synce_timestamp,
                rec_id:rec.id,

                // on_behalf:this.behalf,
                // last_on_behalf:this.behalf,


            });
        }else {
            console.log(this.refRec);
        }



    }

    onSubmit() {
        if (this.form.valid) {
            let user: User = new User();
            user.name = null;
            user.status = null;
            user.picture = null;
            user.password = this.form.controls['oldPassword'].value;
            user.newPassword = this.form.controls['newPassword'].value;
            let newPass = this.form.controls['newPassword'].value;
            let confirmPass = this.form.controls['confirmPassword'].value;
            // let oldpassword = this.form.controls['oldPassword'].value;
            // this.oldPass = user.password
            // if (this.oldPass == oldpassword) {
            if (confirmPass == newPass) {
                if (confirmPass.length >= 8 && newPass.length >= 8) {

                    if (this.id) {
                        user.id = this.id;
                        this.userService.checkPassword(user).subscribe(
                            ruser => {
                                this.msgs = [];
                                if (ruser.result) {
                                    this.msgs.push({
                                        severity: 'success',
                                        summary: '',
                                        detail: this.translate.instant(ruser.message)
                                    });
                                } else {
                                    this.msgs.push({
                                        severity: 'error',
                                        summary: '',
                                        detail: this.translate.instant(ruser.message)
                                    });
                                }
                                this.form.reset();
                                localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                            }, error => {
                                console.log(error);
                            }
                        );
                    } else {

                        console.log('You can\'t create new user form here')
                    }
                    /*}else{
                        this.msgs = [];
                        this.msgs.push({
                            severity: 'error',
                            summary: '',
                            detail: this.translate.instant('The new passwords doesn\'t match')
                        });
                      }*/

                } else {
                    this.msgs = [];
                    this.msgs.push({
                        severity: 'error',
                        summary: '',
                        detail: this.translate.instant('password fields should have minimum 4 chars')
                    });
                }
            } else {
                this.msgs = [];
                this.msgs.push({
                    severity: 'error',
                    summary: '',
                    detail: this.translate.instant('The new passwords doesn\'t match')
                });

            }

        } else {
            this.msgs = [];
            this.msgs.push({
                severity: 'error',
                summary: '',
                detail: this.translate.instant('Please fill inputs with red border')
            });
            this.validateAllFormFields(this.form)
        }
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({onlySelf: true});
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    close() {
        this.activeModal.dismiss('done');
    }

    restoreLog(log: Log) {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                console.log("before dismiss");
                //
                return true;
            }
        };
        this.modalRef = this.modalService.open(this.refShow, options);
        this.modalRef.result.then(() => {
            this.activeModal.dismiss('done');
        }, () => {
            console.log('Backdrop click')
        });
        this.modalRef.componentInstance.oldData = log.old;
        this.modalRef.componentInstance.newData = log.new;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/parent-show/parent-show.component.ts